import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { ReactSortable } from 'react-sortablejs';

import Header from 'components/Header';
import Bundle from 'components/Admin/Bundle/Bundle';
import BundleAdd from 'components/Admin/Bundle/BundleAdd';
import BundleEdit from 'components/Admin/Bundle/BundleEdit';

import Paths from 'paths';

import { sortBundle } from 'redux/actions';

class Bundles extends Component{
    render() {        
        return (
            <section id="la-soundbox-container">
                <Header returnLink={Paths.PATH_ADMIN_HOME}/>
                <h1>Tous les bundles</h1>
                <ReactSortable 
                    handle=".soundbox-grid-bar-handle" 
                    className='soundbox-grid-bar-container bundles-list'
                    list={this.props.bundles.map(bundle => [bundle.id])}
                    setList={() => {}}
                    onEnd={this.onBundleDragAndDrop}>
                    {
                        this.props.bundles.map(
                            (bundle) => bundle.id === +this.props.match.params.bundleId ?
                                <BundleEdit {...this.props} bundle={bundle} key={bundle.id} /> 
                                :
                                <Bundle bundle={bundle} key={bundle.id}/>
                        )
                    }
                </ReactSortable>
                <div className='soundbox-grid-bar-container bundles-list'>
                { this.props.match.path === Paths.PATH_ADMIN_ADD_BUNDLES ? 
                    <BundleAdd {...this.props}></BundleAdd> : 
                    <NavLink to={Paths.PATH_ADMIN_ADD_BUNDLES} className={'button-large'}>Nouveau Bundle</NavLink> }
                </div>
            </section>
        )
    }

    onBundleDragAndDrop = (evt) => {
        if(evt.oldIndex !== evt.newIndex) {
            this.props.sortBundle(evt.oldIndex, evt.newIndex);
        }   
    };
}

const mapStateToProps = (state) => {
    return {
        bundles: state.bundles
    }
};

const mapDispatchToProps = { sortBundle };

export default connect(mapStateToProps, mapDispatchToProps)(Bundles);
